/// <reference path="GamesRace.js" />

/* MIT - May Induce Trouble */
class GamesRaceOpponent {
	constructor(minTimeout, maxTimeout, probabilityCorrect, endPosition, processAnswerUrl) {
		this.position = 0;
		this.questionNumber = 0;
		this.endPosition = endPosition;
		this.minTimeout = minTimeout;
		this.maxTimeout = maxTimeout;
		this.probabilityCorrect = probabilityCorrect;
		this.processAnswerUrl = processAnswerUrl;
		this.timer = window.setTimeout(function() { this.answer(); }.bind(this), this.getTimeout());
	}

	getTimeout() {
		return this.minTimeout + Math.random() * (this.maxTimeout - this.minTimeout);
	}

	answer() {
		if (GamesMultiplayerQuizInstance.isOpponentAlive() && this.questionNumber != this.endPosition) {
			this.timeout = this.getTimeout();
			var correct = Math.random() < this.probabilityCorrect;
			if (correct) {
				if (this.position <= this.endPosition - 2) {
					this.position += 2;
				} else {
					this.position = this.endPosition;
				}
			} else {
				if (this.position != 0) {
					this.position--;
				}
			}

			GamesRaceInstance.moveDragonTo(1, this.position);
			axios(new UrlTemplate(this.processAnswerUrl).r('PLH_success', correct).r('PLH_nquestion', -2).url,
				{
					method: 'get'
				}
			).then(this.onSuccess.bind(this));
		}
	}

	onSuccess(req) {
		this.json = req.data;
		if (this.position == this.endPosition) {
			GamesMultiplayerQuizInstance.handleNextPageLoad();
		} else {
			clearTimeout(this.timer);
			this.questionNumber++;
			this.timer = window.setTimeout(function() { this.answer() }.bind(this), this.timeout);
			if (this.questionNumber == this.endPosition) {
				GamesRaceInstance.takeDragonDown(1, this.position);
			}
		}
	}
}
